import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ChooseItemCardAddress = styled.div`
  text-align: left;
  line-height: ${spacing(5)};
  & * {
    color: ${({ theme }) => theme.colors.mainTextColor};
  }
`;

export const $AddressLine = styled.div`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
`;
